import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Model } from 'libx';
import { action, computed, observable } from 'mobx';
import { filter, share } from 'rxjs/operators';
import { collection } from '../../utils/collection';
import { maybeParseDate } from '../../utils/dateUtil';
import { toStream } from '../../utils/mobxUtil';
import { CallParticipant } from './CallParticipant';
export var CallStatus = {
  Unknown: 'Unknown',
  InProgress: 'InProgress',
  Completed: 'Completed'
};
export var Call = (_dec = action.bound, _class = /*#__PURE__*/function (_Model) {
  /**
   *
   * @param {Conversation} conversation
   * @param {() => Member} primeMember
   * @param {*} events$
   */
  function Call(conversation, primeMember, getTime, callEvents$) {
    var _this;
    _classCallCheck(this, Call);
    _this = _callSuper(this, Call);
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "callStatus", _descriptor2, _this);
    _initializerDefineProperty(_this, "dateCreated", _descriptor3, _this);
    _initializerDefineProperty(_this, "dateCompleted", _descriptor4, _this);
    _this.conversation = conversation;
    _this.primeMember = primeMember;
    _this.getTime = getTime;

    /**
     * Call Participants
     */
    _this.participants = collection({
      create: function create(attrs) {
        return new CallParticipant(_this, _this.primeMember);
      },
      getDataId: function getDataId(d) {
        return d.user_public_id;
      },
      getModelId: function getModelId(d) {
        return d.userPublicId;
      }
    });
    _this.events$ = callEvents$.pipe(filter(function (e) {
      return e.call === _this;
    }), share());
    _this.completed$ = toStream(function () {
      return _this.callStatus === CallStatus.Completed;
    }).pipe(filter(Boolean), share());
    return _this;
  }

  /**
   * Participants that are not the current user.
   */
  _inherits(Call, _Model);
  return _createClass(Call, [{
    key: "otherParticipants",
    get: function get() {
      return this.participants.filter(function (p) {
        return p.member.isCurrentUser === false;
      });
    }

    /**
     * Gets the current user participant if possible.
     */
  }, {
    key: "currentUserParticipant",
    get: function get() {
      var _this$participants$fi;
      return (_this$participants$fi = this.participants.find(function (p) {
        return p.member.isCurrentUser;
      })) !== null && _this$participants$fi !== void 0 ? _this$participants$fi : null;
    }
  }, {
    key: "canCurrentUserJoinCall",
    get: function get() {
      return this.conversation.participants.some(function (p) {
        return p.member.isCurrentUser;
      });
    }
  }, {
    key: "ensureParticipant",
    value: function ensureParticipant(participantUserId, participantUserPublicId) {
      return this.participants.set({
        user_id: participantUserId,
        user_public_id: participantUserPublicId
      });
    }

    /**
     * Used to optimistically mark the call as completed. Called when the
     * current user is declining or hanging up the call.
     *
     * We only do this if there are 2 or less participants, since the logic
     * surrounding more than that is complex and best left to the server.
     */
  }, {
    key: "maybeMarkCompleted",
    value: function maybeMarkCompleted() {
      var participantCount = this.participants.items.length;
      if (participantCount > 2) {
        return;
      }
      this.dateCompleted = this.getTime();
      this.callStatus = CallStatus.Completed;
    }
  }, {
    key: "parse",
    value: function parse(json) {
      this.participants.reset(json.participants);
      return {
        id: json.id,
        dateCreated: maybeParseDate(json.date_created),
        dateCompleted: maybeParseDate(json.date_completed),
        callStatus: Call.mapCallStatus(json.call_status)
      };
    }
  }], [{
    key: "mapCallStatus",
    value: function mapCallStatus(statusType) {
      switch (statusType) {
        case 'IN_PROGRESS':
          return CallStatus.InProgress;
        case 'COMPLETED':
          return CallStatus.Completed;
        case undefined:
          return undefined;
        default:
          return CallStatus.Unknown;
      }
    }
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "callStatus", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return CallStatus.Unknown;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dateCreated", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return new Date(0);
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "dateCompleted", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "otherParticipants", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "otherParticipants"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentUserParticipant", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentUserParticipant"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canCurrentUserJoinCall", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "canCurrentUserJoinCall"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maybeMarkCompleted", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "maybeMarkCompleted"), _class.prototype), _class);
//# sourceMappingURL=Call.js.map
